export const zoomIn = () => {
  const banners = document.querySelectorAll(
    ".banner-cta .banner-pool-widget__banner"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("zoom-in");
        } else {
          entry.target.classList.remove("zoom-in");
        }
      });
    },
    { threshold: 0.3 }
  );

  banners.forEach((banner) => observer.observe(banner));
};
